import React, { useState, useEffect } from "react";
import './SubcategoriesForm.css';

function Apartment({ additionalAttributes, setAdditionalAttributes, subCategoryId }) {
  const [propertyType, setPropertyType] = useState("");

  // Debug logging
  useEffect(() => {
    console.log('🏠 Apartment form mounted with subCategoryId:', subCategoryId);
    console.log('📋 Current additionalAttributes:', additionalAttributes);
  }, [subCategoryId, additionalAttributes]);

  const handlePropertyTypeChange = (e) => {
    const value = e.target.value;
    console.log('🏘️ Property type changed:', value);
    
    setPropertyType(value);
    setAdditionalAttributes((prev) => {
      const updated = { ...prev, propertyType: value };

      if (value !== "Bina") {
        delete updated.floor;
        delete updated.totalFloors;
        delete updated.hasElevator;
      } else {
        delete updated.hasYard;
      }

      return updated;
    });
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    const parsedValue = value === "true" ? true : value === "false" ? false : value;

    console.log(`🔧 Field changed: ${name} = ${parsedValue} (type: ${typeof parsedValue})`);

    setAdditionalAttributes({
      ...additionalAttributes,
      [name]: parsedValue,
    });
  };

  return (
    <div className="apartment">
      {/* Başlıq */}
      <div>
        <h3>
          Elan Başlığı <span>*</span>
          <span className="tooltip-icon" title="Qısa və aydın başlıq">ℹ️</span>
        </h3>
        <input 
          type="text" 
          name="name" 
          placeholder="2 otaqlı mənzil Nəsimi rayonunda" 
          onChange={handleChange} 
          required 
        />
      </div>

      {/* Ünvan */}
      <div>
        <h3>
          Ünvan <span>*</span>
          <span className="tooltip-icon" title="Rayon, məhəllə, küçə">ℹ️</span>
        </h3>
        <input 
          type="text" 
          name="address" 
          placeholder="Nəsimi rayonu, 8-ci kilometr, A.Səhhət küçəsi" 
          onChange={handleChange} 
          required 
        />
      </div>

      {/* Otaq sayı */}
      <div>
        <h3>
          Otaq sayı <span>*</span>
          <span className="tooltip-icon" title="Yataq otaqlarının sayı">ℹ️</span>
        </h3>
        <select name="roomCount" onChange={handleChange} defaultValue="" required>
          <option value="" disabled>Seçin</option>
          <option value="1">1 otaq</option>
          <option value="2">2 otaq</option>
          <option value="3">3 otaq</option>
          <option value="4">4 otaq</option>
          <option value="5">5 otaq</option>
          <option value="6">6+ otaq</option>
        </select>
      </div>

      {/* Sahə */}
      <div>
        <h3>
          Sahə (m²) <span>*</span>
          <span className="tooltip-icon" title="Ümumi sahə kvadrat metrlə">ℹ️</span>
        </h3>
        <input 
          type="number" 
          name="area" 
          min="5" 
          max="1000" 
          placeholder="85"
          onChange={handleChange} 
          required 
        />
      </div>

      {/* Mənzil tipi */}
      <div>
        <h3>
          Mənzil tipi <span>*</span>
          <span className="tooltip-icon" title="Binanın növü">ℹ️</span>
        </h3>
        <select name="propertyType" onChange={handlePropertyTypeChange} required defaultValue="">
          <option value="" disabled>Seçin</option>
          <option value="Bina">Bina (Apartment)</option>
          <option value="Həyət evi">Həyət evi (House)</option>
          <option value="Villa">Villa</option>
          <option value="Duplex">Duplex</option>
          <option value="Penthouse">Penthouse</option>
        </select>
      </div>

      {/* Əgər Bina tipidirsə */}
      {propertyType === "Bina" && (
        <>
          <div>
            <h3>
              Mərtəbə <span>*</span>
              <span className="tooltip-icon" title="Mənzilin mərtəbəsi">ℹ️</span>
            </h3>
            <input 
              type="number" 
              name="floor" 
              min="1" 
              max="50" 
              placeholder="5"
              onChange={handleChange} 
              required 
            />
          </div>
          <div>
            <h3>
              Binanın mərtəbə sayı <span>*</span>
              <span className="tooltip-icon" title="Binanın ümumi mərtəbə sayı">ℹ️</span>
            </h3>
            <input 
              type="number" 
              name="totalFloors" 
              min="1" 
              max="100" 
              placeholder="9"
              onChange={handleChange} 
              required 
            />
          </div>
          <div>
            <h3>
              Lift <span>*</span>
              <span className="tooltip-icon" title="Lift varmı?">ℹ️</span>
            </h3>
            <select name="hasElevator" onChange={handleChange} required defaultValue="">
              <option value="" disabled>Seçin</option>
              <option value="true">Bəli ✅</option>
              <option value="false">Xeyr ❌</option>
            </select>
          </div>
        </>
      )}

      {/* Əgər Bina deyilsə */}
      {(propertyType === "Həyət evi" || propertyType === "Villa") && (
        <div>
          <h3>
            Həyəti var? <span>*</span>
            <span className="tooltip-icon" title="Açıq həyət sahəsi">ℹ️</span>
          </h3>
          <select name="hasYard" onChange={handleChange} required defaultValue="">
            <option value="" disabled>Seçin</option>
            <option value="true">Bəli ✅</option>
            <option value="false">Xeyr ❌</option>
          </select>
        </div>
      )}

      {/* Digər sahələr */}
      <div>
        <h3>
          İstilik sistemi <span>*</span>
          <span className="tooltip-icon" title="Qızdırma sistemi">ℹ️</span>
        </h3>
        <select name="heatingSystem" onChange={handleChange} required defaultValue="">
          <option value="" disabled>Seçin</option>
          <option value="Kombi">Kombi (Individual)</option>
          <option value="Mərkəzi">Mərkəzi (Central)</option>
          <option value="Kondisioner">Kondisioner</option>
          <option value="Elektrik">Elektrik radiator</option>
          <option value="Yoxdur">Yoxdur</option>
        </select>
      </div>

      <div>
        <h3>
          Qaraj <span>*</span>
          <span className="tooltip-icon" title="Park yeri və ya qaraj">ℹ️</span>
        </h3>
        <select name="hasGarage" onChange={handleChange} required defaultValue="">
          <option value="" disabled>Seçin</option>
          <option value="true">Bəli ✅</option>
          <option value="false">Xeyr ❌</option>
        </select>
      </div>

      <div>
        <h3>
          Balkon <span>*</span>
          <span className="tooltip-icon" title="Balkon və ya loca">ℹ️</span>
        </h3>
        <select name="hasBalcony" onChange={handleChange} required defaultValue="">
          <option value="" disabled>Seçin</option>
          <option value="true">Bəli ✅</option>
          <option value="false">Xeyr ❌</option>
        </select>
      </div>

      <div>
        <h3>
          Təmir vəziyyəti <span>*</span>
          <span className="tooltip-icon" title="Daxili təmir">ℹ️</span>
        </h3>
        <select name="renovationStatus" onChange={handleChange} defaultValue="" required>
          <option value="" disabled>Seçin</option>
          <option value="Təmirli">Təmirli (Yeni təmir)</option>
          <option value="Orta təmir">Orta təmir</option>
          <option value="Təmirsiz">Təmirsiz (Köhnə)</option>
          <option value="Tikintidə">Tikintidə (Yeni)</option>
        </select>
      </div>

      <div>
        <h3>
          Sənəd tipi <span>*</span>
          <span className="tooltip-icon" title="Mülkiyyət sənədi">ℹ️</span>
        </h3>
        <select name="documentType" onChange={handleChange} defaultValue="" required>
          <option value="" disabled>Seçin</option>
          <option value="Kupça">Kupça (Deed)</option>
          <option value="Bələdiyyə">Bələdiyyə sənədi</option>
          <option value="Müqavilə">Müqavilə</option>
          <option value="İcarə">İcarə müqaviləsi</option>
          <option value="Yoxdur">Sənəd yoxdur</option>
        </select>
      </div>

      <div>
        <h3>
          Əşyalıdır? <span>*</span>
          <span className="tooltip-icon" title="Mebel və texnika">ℹ️</span>
        </h3>
        <select name="isFurnished" onChange={handleChange} required defaultValue="">
          <option value="" disabled>Seçin</option>
          <option value="true">Bəli (Əşyalı) ✅</option>
          <option value="false">Xeyr (Boş) ❌</option>
        </select>
      </div>

      <div>
        <h3>
          Yeni tikilidir? <span>*</span>
          <span className="tooltip-icon" title="Son 5 il ərzində tikilmiş">ℹ️</span>
        </h3>
        <select name="isNewBuilding" onChange={handleChange} required defaultValue="">
          <option value="" disabled>Seçin</option>
          <option value="true">Bəli (Yeni tikili) ✅</option>
          <option value="false">Xeyr (Köhnə tikili) ❌</option>
        </select>
      </div>

      <div>
        <h3>
          Qaz var? <span>*</span>
          <span className="tooltip-icon" title="Təbii qaz xətti">ℹ️</span>
        </h3>
        <select name="hasGas" onChange={handleChange} required defaultValue="">
          <option value="" disabled>Seçin</option>
          <option value="true">Var ✅</option>
          <option value="false">Yoxdur ❌</option>
        </select>
      </div>

      <div>
        <h3>
          Su var? <span>*</span>
          <span className="tooltip-icon" title="İçməli su">ℹ️</span>
        </h3>
        <select name="hasWater" onChange={handleChange} required defaultValue="">
          <option value="" disabled>Seçin</option>
          <option value="true">Var ✅</option>
          <option value="false">Yoxdur ❌</option>
        </select>
      </div>

      <div>
        <h3>
          İşıq var? <span>*</span>
          <span className="tooltip-icon" title="Elektrik şəbəkəsi">ℹ️</span>
        </h3>
        <select name="hasElectricity" onChange={handleChange} required defaultValue="">
          <option value="" disabled>Seçin</option>
          <option value="true">Var ✅</option>
          <option value="false">Yoxdur ❌</option>
        </select>
      </div>

      <div>
        <h3>
          İnternet var? <span>*</span>
          <span className="tooltip-icon" title="İnternet qoşulması">ℹ️</span>
        </h3>
        <select name="hasInternet" onChange={handleChange} required defaultValue="">
          <option value="" disabled>Seçin</option>
          <option value="true">Var ✅</option>
          <option value="false">Yoxdur ❌</option>
        </select>
      </div>

      <div>
        <h3>
          Kondisioner var? <span>*</span>
          <span className="tooltip-icon" title="A/C sistemi">ℹ️</span>
        </h3>
        <select name="hasAirConditioner" onChange={handleChange} required defaultValue="">
          <option value="" disabled>Seçin</option>
          <option value="true">Var ✅</option>
          <option value="false">Yoxdur ❌</option>
        </select>
      </div>
    </div>
  );
}

export default Apartment;